exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/wamp/www/sportal/pmi/web/src/app/main/profile/profile.component.css
// module id = ../../../../../src/app/main/profile/profile.component.css
// module chunks = main